
/* eslint-disable react/jsx-max-depth, capitalized-comments, multiline-comment-style, no-tabs */
import { Alert, Button, Card, Col, Row } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import Helmet from "react-helmet";

import ForgotPasswordModal from "./ForgotPasswordModal";
import LoginForm from "./LoginForm";

import loginImage from "../../assets/images/login-image.webp";
import { useAuth } from "../../services/wp.auth.service";

const Login = () => {
	const { user } = useAuth();
	const navigate = useNavigate();

	const { state } = useLocation();
	const [forgotPasswordOpen, setForgotPasswordOpen] = useState(false);
	const toggleForgotPassword = useCallback(() => setForgotPasswordOpen(!forgotPasswordOpen));

	const imageStyles = {
		backgroundImage: `url(${loginImage})`,
		backgroundPosition: "center center",
		backgroundSize: "cover"
	};

	useEffect(() => {
		if (user) {
			navigate("/");
		}
	}, [user]);

	return (
		<>
			<Helmet>
				<title>
					{"Login"}
				</title>
			</Helmet>

			<Card className="my-4">
				<Row className="gx-0">
					<Col lg={8} xs={12}>
						<div className="p-4 p-lg-5">
							<h1 className="mb-1 text-neutral6">
								Log in to
							</h1>

							<h2 className="text-blue">
								Register for Classes
							</h2>

							<p className="text-neutral6">
								To register for your selected classes, sign in to your Life with Cancer account.
							</p>

							{state?.message ? <Alert variant={state.variant || "success"}>{state.message}</Alert> : null}

							<LoginForm className="mb-4" />

							<div className="text-center">
								<Button as={Link} className="me-3" to="/" variant="link">
									{"Back to Home"}
								</Button>

								<Button
									as={Link}
									className="me-3"
									onClick={toggleForgotPassword}
									to="#"
									variant="link"
								>
									{"Forgot Password"}
								</Button>

								<Button className="me-3" disabled={!window.lwc_sso_active} href={"/sso/login"} variant="link">
									Staff Login
								</Button>
							</div>

						</div>

						<Row className="bg-bluetype5 gx-0 p-5 align-items-center">
							<Col className="text-center text-med-end mb-3 mb-md-0" md={6} sm={12}>
								<p className="mb-1 text-neutral3 text-uppercase fw-bold">
									Don&apos;t have an account?
								</p>
								<p className="text-neutral3 mb-0">
									Sign Up for one now. It&apos;s free.
								</p>
							</Col>
							<Col className="text-center text-md-end" md={6} sm={12}>
								<Button as={Link} to="/login/register" variant="lightblue">
									Sign Up Now
								</Button>
							</Col>
						</Row>
					</Col>

					<Col lg={4} style={imageStyles} xs={12} />
				</Row>
			</Card>

			<ForgotPasswordModal onHide={toggleForgotPassword} show={forgotPasswordOpen} />
		</>
	);

};

export default Login;
